import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { DButtonComponent } from '../../shared/components/d-button/d-button.component';
import { CardComponent } from '../../shared/components/card/card.component';
import {
  ReactiveFormsModule,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import alloy from '@alloyidentity/web-sdk';
import { WidgetService } from '../../services/widget.service';
import { CommonModule } from '@angular/common';
//import { CookieService } from 'ngx-cookie-service';
import { CookieService} from 'ngx-cookie';
import { WindowRefService } from '../../services/window-ref.service';
import { Subscription, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpParams } from '@angular/common/http';
import { UtilsService } from '../../services/utils.service';
import { BrandingService } from '../../services/branding.service';
const urlConvertorObject: {[key: string]: string} = {
  SAMLRequest: `${environment.oauth.issuer}/saml/route`,
  client_id : `${environment.oauth.issuer}/route`,
  default : "No Values found"
}
declare global {
  interface window {ForgeRock?: any}
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [DButtonComponent, ReactiveFormsModule, CardComponent, CommonModule, RouterLink],
  providers: [CookieService],

  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})

export class HomeComponent implements OnInit {
  allParams: { [key: string]: string } = {};
  tmx_session: any;
  usernameForm: FormGroup = new FormGroup({});  
  isrisk = false;  
  constructor(
    private widgetSrv: WidgetService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private cookieService: CookieService,
    private windowRef: WindowRefService,
    private utilsSrv: UtilsService
  ) {
    this.showWidget();
   
    this.usernameForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
    });
  }

  private uiConfigSv: BrandingService = inject(BrandingService);

  showWidget() {
    const widget = this.widgetSrv.setWidget('Spark_Main_Authentication');
    if (widget) {
      const widget$ = widget.subscribe((event) => {
        /* journey is complete */
        if (event.journey.completed) {
          console.log(this.allParams)
          this.windowRef.open(this.allParams['goto'], '_self');
        }
      });
    }
  }

  ngOnInit() {
    //.checkSession();    

    this.route.queryParamMap.subscribe((params) => {
      if (params.has('error')) {
        this.isrisk = true;
        // Remove the 'error' parameter from the params map
        const newParams = { ...this.allParams };
        delete newParams['error'];
        this.allParams = newParams;
      }
      params.keys.forEach((key) => {
        if (key !== 'error') {
          this.allParams[key] = params.get(key) || '';
        }
        
      });
      
    });
    //console.log(this.allParams);
    
    const alloyInitParams = {
      key: '6df6e292-ef03-4958-b4e9-479de46c6073',
      //journeyToken: 'J-jGDtTH0cYoVh2vyVnnjG'
    };
    alloy
      .init(alloyInitParams)
      .then((response) => {
        this.tmx_session = response['threatmetrixSessionId'];
      })
      .catch((error) => {
        console.error(error);
      });
  }
 
  signIn(isForm = true, email = null) {    
    const userName = email || this.usernameForm.value.username || '';
    
    if ((this.usernameForm.valid && isForm) || !isForm) {
      this.allParams['login_hint'] = userName;
      this.allParams['tmx_session'] = this.tmx_session;
      let parameter = new HttpParams();
      console.log('this.allParams');
      console.log(this.allParams);
      let keyVal = 'default';
      for (const key in this.allParams) {
        if (this.allParams.hasOwnProperty(key)) {
          parameter = parameter.set(key, this.allParams[key]);
        }
        if(key in urlConvertorObject){
          keyVal = key;
        }
      }
      
     /*  const externalUrl = 'https://risk-detection-router-api-lawlr1.rajrd4-2.usa-e1.cloudhub.io/route';
      const urlWithParams = `${externalUrl}?${parameter.toString()}`;
      this.cookieService.set('urlWithParams', urlWithParams, 1, 'urlWithParams', '.day1cloud.com');
     */
      //console.log(keyVal);
      const externalUrl = urlConvertorObject[keyVal];
      console.log(externalUrl);
      const urlWithParams = `${externalUrl}?${parameter.toString()}`;
      console.log(urlWithParams);
      this.cookieService.put('tmx_session', this.allParams['tmx_session'], {expires: this.utilsSrv.daysNow(1)});
      this.cookieService.put('urlWithParams', urlWithParams, {expires: this.utilsSrv.daysNow(1)});
      console.log(this.usernameForm.value.username)
      this.cookieService.put('login_hint', decodeURIComponent(userName),{domain:'.day1cloud.com', storeUnencoded: true} /* 1, '/', '.day1cloud.com' */);       

      // step:1 store email
      localStorage.setItem('email', userName);
      
      this.windowRef.open(urlWithParams, '_self');
    }
  }
  
  get buttonStatus() {
    return this.usernameForm.invalid &&
      (this.usernameForm.dirty || this.usernameForm.touched)
      ? ['green', 'disabled']
      : ['green'];
  }

  checkSession() {
     console.log('data session url')
    const raw = this.cookieService.get('urlWithParams');
    if(!raw) return
    try{
      ['FRAuthTree', 'FRAuthState', 'FR-AuthResumeURI','authId', 'username'].forEach(k => {
        localStorage.removeItem(k)
        sessionStorage.removeItem(k)
      })
    } catch(e) {
      console.error(e)
    }
    console.log(raw)
      const u = new URL(raw);
      console.log(u);
      ['login_hint','error', 'tmx_session', 'username', 'IDToken1'].forEach(k => u.searchParams.delete(k)) 
      u.searchParams.set('prompt','login');
      u.searchParams.set('max_age','0');
      console.log('u.toString()')
      console.log(u.toString())
     // window.open(outer.toString(), '_self');
    
 
  }


  get isValidInput(): boolean {
    return this.usernameForm.invalid && (this.usernameForm.dirty || this.usernameForm.touched)
  }


}
